import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "@/locales/en/common.json";
import es from "@/locales/es/common.json";
import pt from "@/locales/pt/common.json";

const isDev = import.meta.env.DEV;

i18n.use(initReactI18next).init({
  resources: {
    en: { common: en },
    es: { common: es },
    pt: { common: pt },
  },
  lng: "en",
  fallbackLng: "en",
  supportedLngs: ["en", "es", "pt"],
  defaultNS: "common",
  ns: ["common"],
  interpolation: {
    escapeValue: false, // React already escapes
  },
  ...(isDev && {
    saveMissing: true,
    missingKeyHandler: (_lngs: readonly string[], _ns: string, key: string) => {
      console.warn(`[i18n] Missing key: "${key}"`);
    },
  }),
});

export default i18n;
